export const mapToArray = (obj) =>
  Object.entries(obj).map(([uid, value]) => ({ uid, ...value }));
